import { createFileRoute } from '@tanstack/react-router';
import { PaginaEmDesenvolvimento } from '@/components/layout/PaginaEmDesenvolvimento';

export const Route = createFileRoute('/_admin/circuit-breakers')({
  component: CircuitBreakersPage,
});

function CircuitBreakersPage() {
  return <PaginaEmDesenvolvimento label="Circuit Breakers" />;
}
